export default __webpack_public_path__ + "04368197d9a20c4733b6c9f0838f8423.jpg";